<template>
    <div>
        <Row type="none" class="bg-white rounded shadow mb-4">

            <Modal
                :text="modalText"
                id="modal_show1"
            />

            <Modal
                :text="modalText"
                id="modal_router"
                :on-ok-pressed="goNext"
                :is-ok-only="false"
                ok-text="yes"
                cancel-text="no"
            />

            <div class="container grid grid-cols-3 gap-3 py-5">
                <div class="col-span-1 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                        {{ $t('product.name') }}
                    </div>

                    <b-form-input
                        class="h-11 border-gray-300 focus:ring-0"
                        @input="onBarcodeScanned"
                        v-model="search.productName"
                    />
                </div>

                <div class="col-span-1 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                        {{ $t('warehouse.title') }}
                    </div>

                    <b-form-select @change="fetchPIW" v-model="search.warehouseId" class="h-11 border-gray-300 focus:ring-0">
                        <b-form-select-option :value="null">{{ $t('filter.all') }}</b-form-select-option>
                        <b-form-select-option v-for="item in warehouses" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </b-form-select-option>
                    </b-form-select>
                </div>

                <div class="col-span-1 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                        {{ $t('productPriceModify.marja') }}
                    </div>

                    <b-form-input
                        class="h-11 border-gray-300 focus:ring-0"
                        type="number"
                        v-model="marja"
                        @input="setMarja"
                    />
                </div>
            </div>

        </Row>

        <Row type="none" class="bg-white rounded shadow">

            <div class="grid grid-cols-6 gap-3">

                <div class="col-span-6 md:col-span-2 pl-3" style="max-height: 700px; overflow-y: scroll">
                    <div
                        v-for="piw of this.filteredPiws"
                        :key="piw.id"
                        style="height: 50px; border-bottom: 1px solid #c5c5c5; cursor: pointer;"
                        :class="{'bg-info text-white' : bgColor(piw)}"
                        @click="select(piw)"
                        class="px-2 font-weight-bold overflow-hidden d-flex align-items-center justify-content-between"
                    >
                        <div style="max-width: 75%">
                            {{ piw.product.name.slice(0, 50) }}
                            <template v-if="piw.product.name.length > 50">...</template>
                        </div>
                        <div>{{ piw.amount }} {{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</div>
                    </div>
                </div>

                <div v-if="modelForm.modifyProductItemDtos.length" class="col-span-6 md:col-span-4 px-0 mt-4 mt-md-0" style="max-height: 700px; overflow-y: scroll">
                    <ProductModifyMakeListTable
                        :piw-list="modelForm.modifyProductItemDtos"
                        :is-need-refresh="isNeedRefresh"
                        @deleteOneRow="deleteOne"
                        @refresh="isNeedRefresh = !isNeedRefresh"
                        class="px-0"
                    />
                </div>
            </div>

            <div class="container grid grid-cols-12 pb-5">
                <div class="col-start-11 col-span-2">
                    <SubmitRow
                        sm-size="12"
                        md-size="12"
                        text="save"
                        :is-loading="isLoading"
                        :do-action="save"
                        :is-disabled="checkForValid() || modelForm.modifyProductItemDtos.length === 0"
                    />
                </div>
            </div>
        </Row>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import SubmitRow from "@/components/SubmitRow.vue";
import Modal from "@/components/html/Modal.vue";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import ProductModifyMakeListTable from "@/components/ProductModifyMakeListTable.vue";
import Row from "@/components/html/Row.vue";

export default {
    name: "InventoryMake",
    components: {Row, ProductModifyMakeListTable, Modal, SubmitRow},
    mixins: [currencyFormatMixin, currencyRateMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'inventory.title'},
            ],
            modalText: '',
            isLoading: false,
            next: null,
            isNeedRefresh: false,
            search: {
                productName: '',
                warehouseId: null
            },
            marja: 10,
            modelForm: {
                amount: 0,
                prognosisRate: 0,
                difference: 0,
                modifyProductItemDtos: []
            },
            piws: null,
            warehouses: null
        }
    },
    computed: {
        ...mapGetters(['getProductsInWarehouses', 'getWarehouses']),
        filteredPiws() {
            if (this.search.productName !== '') {
                return this.piws.filter((item) => {
                    return this.search.productName.toLowerCase().split(' ').every(v => item.product.name.toLowerCase().includes(v))
                })
            } else {
                return this.piws
            }
        },
    },
    methods: {
        ...mapActions([
            'fetchAllProductsInWarehouses',
            'searchProductInWarehouse',
            'fetchWarehousesSearch',
            'pushModifyProduct',
            'setBreadcrumbItems'
        ]),
        onBarcodeScanned(barcode) {
            if (this.isNumber(barcode)) {
                this.piws.find((piw) => {
                    if (piw.product.barCode === barcode) {
                        this.select(piw)
                    }
                })
            }
        },
        isNumber(n) {
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n)
        },
        goNext() {
            this.next()
        },
        fetchPIW() {
            this.$root.showOverlay = true

            if (this.search.warehouseId === null) {
                this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true

                this
                    .fetchAllProductsInWarehouses()
                    .then(() => {
                        this.piws = this.getProductsInWarehouses
                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show1')
                    })
            } else {
                this
                    .searchProductInWarehouse(this.search)
                    .then(() => {
                        this.piws = this.getProductsInWarehouses
                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show1')
                    })
            }
        },
        select(piw) {
            if (this.modelForm.modifyProductItemDtos.find((item) => item.id === piw.id)) {
                let index = this.modelForm.modifyProductItemDtos.findIndex((item) => item.id === piw.id)
                this.modelForm.modifyProductItemDtos.splice(index, 1)
                piw.isSelected = false
            } else {
                piw.marja = this.marja
                piw.oldPrice = piw.product.sellingPrice
                piw.newPrice = parseFloat(piw.product.sellingPrice) + ((this.marja * parseFloat(piw.product.sellingPrice)) / 100)
                this.modelForm.modifyProductItemDtos.push(piw)
                piw.isSelected = true
            }
        },
        setMarja() {
            this.modelForm.modifyProductItemDtos.forEach((piw) => {
                piw.marja = this.marja
                piw.newPrice = parseFloat(piw.product.sellingPrice) + ((this.marja * parseFloat(piw.product.sellingPrice)) / 100)
            })

            this.isNeedRefresh = !this.isNeedRefresh
        },
        bgColor(piw) {
            return !(piw.isSelected === undefined || piw.isSelected === false);
        },
        deleteOne(index) {
            this.modelForm.modifyProductItemDtos[index].isSelected = false
            this.modelForm.modifyProductItemDtos.splice(index, 1)
        },
        checkForValid() {
            return this.modelForm.modifyProductItemDtos.some((item) => {
                return parseFloat(item.oldPrice) === parseFloat(item.newPrice)
            })
        },
        save() {
            this.$root.showOverlay = true

            let data = this.prepareData()

            this
                .pushModifyProduct(data)
                .then(() => {
                    data.modifyProductItemDtos.forEach((piw) => {
                        delete piw.isSelected
                    })

                    this.$i18nHelper.toUrl('product-modify')
                    this.$root.showOverlay = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        calcDifference() {
            let overPriceProduct = 0
            this.modelForm.modifyProductItemDtos.forEach((piw) => {
                if (piw.newPrice > piw.oldPrice) {
                    overPriceProduct++
                }
            })

            return overPriceProduct
        },
        calcPrognosisRate() {
            return Math.round((this.calcDifference() * 100) / this.modelForm.modifyProductItemDtos.length)
        },
        makeModifiedProductItems() {
            let arr = []
            this.modelForm.modifyProductItemDtos.forEach((piw) => {
                let obj = {}
                obj.oldPrice = piw.oldPrice.toString()
                obj.newPrice = piw.newPrice.toString()
                obj.product = piw.product['@id']

                arr.push(obj)
            })

            return arr
        },
        prepareData() {
            let data = {}
            data.amount = this.modelForm.modifyProductItemDtos.length
            data.difference = this.calcDifference()
            data.prognosisRate = this.calcPrognosisRate()
            data.modifyProductItemDtos = this.makeModifiedProductItems()

            return data
        }
    },
    beforeRouteLeave (to, from , next) {
        if (this.modelForm.modifyProductItemDtos.length > 0 && to.name !== 'product/modified-products') {
            this.modalText = this.$t('beforeLeaveAdvice')
            this.$bvModal.show('modal_router')
            this.next = next
        } else {
            next()
        }
    },
    watch: {
        'modelForm.modifyProductItemDtos'() {
            if (this.modelForm.modifyProductItemDtos.length === 0) {
                this.modelForm.modifyProductItemDtos.forEach((piw) => {
                    piw.isSelected = false
                })
            }
        }
    },
    created() {
        this.$barcodeScanner.init(this.onBarcodeScanned)
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    destroyed() {
        this.$barcodeScanner.destroy()
    },
    mounted() {
        this.$root.showOverlay = true

        window.focus()

        this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true
        this
            .fetchAllProductsInWarehouses()
            .then(() => {
                this.fetchWarehousesSearch(null)
                    .then(() => {
                        this.piws = this.getProductsInWarehouses
                        this.warehouses = this.getWarehouses
                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show1')
                    })
            })
            .catch((reason) => {
                this.$root.showOverlay = false
                this.modalText = reason
                this.$bvModal.show('modal_show1')
            })
    }
}
</script>

<style scoped>
.subtitle {
    color: #7E7E7E;
}

.digit {
    color: #444444;
    font-weight: 600;
}

::-webkit-scrollbar {
    width: 2px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #6539B2;
}
</style>
